module.exports = __webpack_public_path__ + "img/parasight_combust.8bf04147.png";